export default __webpack_public_path__ + "img/36.357367.png";